import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Pressable, StyleSheet, View } from 'react-native';
import {
  Icon,
  ListAction,
  theme,
  useSafeNavigation,
  useSafeRouter,
} from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardAccountSectionAddCardCta = () => {
  const { formatMessage } = useIntl();

  const navigation = useSafeNavigation();
  const router = useSafeRouter();
  const isExpoRouterEnabled = useIsExpoRouterEnabled();

  const label = formatMessage(messages.accountGiftCardsAddGiftCard);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const navigateToAddGiftCard = useCallback(() => {
    if (isExpoRouterEnabled) {
      router?.navigate('/add-gift-card');
      return;
    }

    navigation?.navigate('Modal', { screen: 'AddGiftCard' });
  }, [isExpoRouterEnabled, router, navigation]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Pressable accessibilityLabel={label} onPress={navigateToAddGiftCard}>
      <ListAction.Wrapper hasPressableStyles>
        <View style={styles.container}>
          <ListAction.Icon iconName="IconCreditCard" />

          <View style={styles.content}>
            <ListAction.Text>{label}</ListAction.Text>
          </View>

          <Icon
            name="IconCaretRight"
            color={theme.colors.CHARCOAL}
            width={CARET_ICON_SIZE}
            height={CARET_ICON_SIZE}
          />
        </View>
      </ListAction.Wrapper>
    </Pressable>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountGiftCardsAddGiftCard: {
    defaultMessage: 'Add gift card',
    description: 'Account | Gift Cards | Add Gift Card',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const CARET_ICON_SIZE = 18;

// ─────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'center',
    paddingVertical: theme.spacing['2'],
  },
  content: {
    flex: 1,
  },
});
